(() => {
  if (customElements.get('pinetree-personal-hero')) return;
  customElements.define('pinetree-personal-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.images = [...this.querySelectorAll('.ptph__print')];
      this.buttons = [...this.querySelectorAll('.ptph__dot')];
      this.pause = this.querySelector('.ptph__pause');
      this.active = 3;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = true;
      this.buttons.forEach((button, i) => button.addEventListener('click', () => { this.show(i); this.schedule(); }, {signal}));
      this.pause.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, {signal});
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.updatePause(); this.schedule(); }, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.schedule(); });
      this.observer.observe(this);
      this.querySelector('.ptph__controls').hidden = false;
      this.updatePause();
      this.schedule();
    }
    show(index) {
      if (!this.images[index].complete || !this.images[index].naturalWidth) return;
      this.active = index;
      this.images.forEach((image, i) => image.classList.toggle('is-active', i === index));
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
    updatePause() {
      this.pause.setAttribute('aria-label', this.paused ? 'Afspil animation' : 'Sæt animation på pause');
      this.pause.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && this.visible && !document.hidden) this.timer = setTimeout(() => {this.show((this.active + 1) % this.images.length); this.schedule();}, 3200);
    }
    disconnectedCallback() {clearTimeout(this.timer); this.controller?.abort(); this.observer?.disconnect();}
  });
})();
